import { useState } from 'react';
import { useSelector } from 'react-redux';
import style from './SubtitleImg.module.scss'
import { selectMovie } from '../../../../../redux/movieSlices/MovieSelector'

let SubtitleImg = () => {

    let { movie } = useSelector(selectMovie)

    const [ActiveImg1, setActiveImg1] = useState(false)
    const [ActiveImg2, setActiveImg2] = useState(false)
    const [ActiveImg3, setActiveImg3] = useState(false)
    return (
        <div className={style.subtitle__img}>
            <span>Photo materials</span>
            <div className={style.img__container}>
                <img className={ActiveImg1 ? style.imgActive1 : style.img1} src={movie.large_screenshot_image1} onClick={() => setActiveImg1(!ActiveImg1)} />
                <img className={ActiveImg2 ? style.imgActive2 : style.img2} src={movie.large_screenshot_image2} onClick={() => setActiveImg2(!ActiveImg2)} />
                <img className={ActiveImg3 ? style.imgActive3 : style.img3} src={movie.large_screenshot_image3} onClick={() => setActiveImg3(!ActiveImg3)} />
            </div>
        </div>
    )
}

export default SubtitleImg;